import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';
import dayjs from "dayjs";

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            form: {
                name: Vue.prototype.$lang('createLocation.name'),
                address: '',
                latitude: 55.748144,
                longitude: 37.623201,
                toro_id: null,
                working_hours: null,
                pickup: false,
                created_at: dayjs().format(),
                updated_at: dayjs().format(),
                cemetery_type_id: window.laravel.locationTypes.cemetery,
                region_id: null
            },
            locationTypes: []
        }
    },
    getters: {
        form: (state) => {
            return state.form;
        },
        locationTypes: (state) => {
            return state.locationTypes
        }
    },
    mutations: {
        setForm(state, value) {
            window.Vue.set(state, 'form', value);
        },
        setLocationTypes(state, value) {
            window.Vue.set(state, 'locationTypes', value);
        }
    },
    actions: {
        getLocationTypes({commit}) {
            return new Promise( (resolve, reject) => {
                ApiService.get('/cemetery/types')
                    .then((response) => {
                        commit('setLocationTypes', response.data)
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            })
        },
        getCemetery({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.get('/location/'+ id)
                    .then((response) => {
                        commit('setForm', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        createCemetery({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.post('/location', form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        editCemetery({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.update('/location/'+form.id, form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        clearForm({commit}) {
            const form = {
                name: 'название кладбища',
                address: '',
                latitude: 55.748144,
                longitude: 37.623201,
                toro_id: null,
                working_hours: null,
                pickup: false,
                created_at: dayjs().format(),
                updated_at: dayjs().format(),
                cemetery_type_id: window.laravel.locationTypes.cemetery
            };

            commit('setForm', {...form});
        }
    }
};


